var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.2928932,2.12138481 C17.2600493,1.15422868 18.66971,0.776511208 19.9908699,1.13051491 C21.3120297,1.48451861 22.343973,2.51646189 22.6979767,3.83762171 C23.0519804,5.15878153 22.6742629,6.56844227 21.7071068,7.53559836 L8.20710678,21.0355984 C8.08405115,21.158654 7.9310123,21.2474659 7.76311741,21.2932554 L2.26311741,22.7932554 C1.51661849,22.996846 0.831645565,22.3118731 1.03523618,21.5653742 L2.53523618,16.0653742 C2.5810257,15.8974793 2.66983759,15.7444404 2.79289322,15.6213848 L16.2928932,2.12138481 Z M19.4732318,3.06236656 C18.8422561,2.89329714 18.169013,3.07369208 17.7071068,3.53559835 L4.394,16.848 L3.424,20.403 L6.98,19.433 L20.2928932,6.12138478 C20.7163073,5.69797072 20.9031737,5.09697504 20.8011512,4.51373752 L20.766125,4.35525979 C20.5970556,3.7242841 20.1042075,3.23143599 19.4732318,3.06236656 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.000000, -0.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b094c6c74632324170403fcd5430fcdd.svg";
export { ForwardRef as ReactComponent };